function TransactionController ( $routeParams ) {
  "ngInject";

  var vm = this;

  vm.orderNumber = $routeParams.orderNumber;
  vm.orderTotal = $routeParams.orderTotal;
}

module.exports = TransactionController;